import React, {useContext, useEffect, useState} from 'react';
import EnhancedTable from '../components/EnhancedTable';
import  {getData} from '../utils/apiUtils';
import { ErrorContext } from "../utils/constants";
import { getCurrentYear } from '../utils/dateUtils';

const upcomingMilestonsHeadCells = [
  { id: 'id', numeric: false, label: 'Milestone Number' },
  { id: 'name', numeric: false, label: 'Milestone Name' },
  { id: 'initiativeName', numeric: false, label: 'Initiative Name' },
  { id: 'statusName', numeric: false, label: 'Status' },
  { id: 'endDate', numeric: false, label: 'Due Date', format: 'date' },
];

const currentInitiativesHeadCells = [
  { id: 'id', numeric: false, disablePadding: false, label: 'Initiative Number' },
  { id: 'initiative_name', numeric: false, disablePadding: false, label: 'Initiative Name' },
  { id: 'status', numeric: false, disablePadding: true, label: 'Status' },
  { id: 'max_date', numeric: false, disablePadding: true, label: 'Due Date', format: 'date' },
  { id: 'netCash', numeric: false, disablePadding: true, label: `Net Cash in ${getCurrentYear()}`, format: 'currency' },
];

export default function MyInitiatives({current})  {
  const [ currentInitiatives, setCurrentInitiatives ] = useState([]);
  const [ upcomingMilestones, setUpcomingMilestones ] = useState([]);
  const { triggerError } = useContext(ErrorContext);

  const onError = () => triggerError({
      title: 'Communication Error',
      description: 'We were unable to read your milestone and initiative data from the server. Please try again.',
      onRetry: () => window.location.reload(),
  });

  const fetchData = () => {
      getData(`/dashboards/mycurrentinitiatives?current=${current}` , setCurrentInitiatives, onError);
      getData(`/dashboards/myupcomingmilestones?current=${current}` , setUpcomingMilestones, onError);
  };

  useEffect(() => {
    document.title = `Rise by TransAlta My ${current ? 'Current': 'Past'} Initiatives Dashboard`;
  }, [current]);

  useEffect(fetchData, [current]);
  if (current) {
    return (
      <div>
        <h2>Upcoming Milestones</h2>
        Here are the upcoming milestones assigned to you.
        <EnhancedTable id='6daadd02-62e3-4aed-af78-5bce2b768318'
                       headCells={upcomingMilestonsHeadCells}
                       rows={upcomingMilestones}
                       allowExport={true}
                       exportFilename='Upcoming Milestones'
                       clickData={{url: '/ui/initiativemilestones/', key: 'initiative_id'}}/>
        <p/>
        <h2>Current Initiatives</h2>
        Here is a list of your current initiatives.
        <EnhancedTable id='e14b9c87-86b1-4d12-a37d-ecd3048558c2'
                       headCells={currentInitiativesHeadCells}
                       rows={currentInitiatives}
                       allowExport={true}
                       exportFilename='Current Initiatives'
                       clickData={{url: '/ui/initiativecard/', key: 'id'}}/>
      </div>
    );
  }
  return (
    <div>
      <h2>All Milestones</h2>
      Here are the all milestones assigned to you.
      <EnhancedTable id='80c64a0d-ff7f-48cb-b0d0-7659e3b3b0ef' 
                     headCells={upcomingMilestonsHeadCells}
                     rows={upcomingMilestones}
                     allowExport={true}
                     exportFilename='Upcoming Milestones'
                     clickData={{url: '/ui/initiativemilestones/', key: 'initiative_id'}}/>
      <p/>
      <h2>Past Initiatives</h2>
      Here is a list of your past initiatives.
      <EnhancedTable id='d9938811-dcb9-48b6-9994-2f2bd25d38fe'
                     headCells={currentInitiativesHeadCells}
                     rows={currentInitiatives}
                     allowExport={true}
                     exportFilename='Current Initiatives'
                     clickData={{url: '/ui/initiativecard/', key: 'id'}}/>
    </div>
  );
}
